import { render, staticRenderFns } from "./Subnote.vue?vue&type=template&id=3afddf93&"
import script from "./Subnote.vue?vue&type=script&lang=js&"
export * from "./Subnote.vue?vue&type=script&lang=js&"
import style0 from "./Subnote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports